import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logger from "../../utils/logging";
import { AUTH_REDIRECT_STORAGE_KEY } from "../../services/UserAuthService";

const OAuth2Callback: React.FC = () => {
    const navigate = useNavigate();
    const { t } = useTranslation("auth");

    useEffect(() => {
        // This component handles the OAuth2 callback
        // Keycloak will process the callback automatically
        logger.debug("OAuth2 callback received, processing...", {
            location: window.location.href,
            searchParams: new URLSearchParams(window.location.search).toString(),
            hasCode: window.location.search.includes("code="),
            hasState: window.location.search.includes("state="),
            hasError: window.location.search.includes("error="),
        });

        // Check for OAuth2 errors in URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const error = urlParams.get("error");
        const errorDescription = urlParams.get("error_description");

        if (error) {
            logger.error("OAuth2 callback error detected:", {
                error,
                errorDescription,
                state: urlParams.get("state"),
                location: window.location.href,
            });

            // For any error, redirect to login page
            navigate("/login", { replace: true });
            return;
        }

        // After successful authentication, redirect to the intended page
        // Check if there's a stored redirect URL from before login
        const storedRedirect = sessionStorage.getItem(AUTH_REDIRECT_STORAGE_KEY);
        if (storedRedirect === "undefined" || storedRedirect === "null") {
            logger.warn(
                "storedRedirect is undefined or string undefined/null: " +
                    storedRedirect +
                    " (type " +
                    typeof storedRedirect +
                    ")",
            );
        }
        const redirectTo = storedRedirect && storedRedirect !== "undefined" ? storedRedirect : "/";

        sessionStorage.removeItem(AUTH_REDIRECT_STORAGE_KEY);

        // Small delay to ensure Keycloak has processed the callback
        setTimeout(() => {
            navigate(redirectTo, { replace: true });
        }, 100);
    }, [navigate]);

    return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
            <div className="text-center">
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">{t("common:loading")}</span>
                </div>
                <p className="mt-3">{t("oauth.processing")}</p>
            </div>
        </div>
    );
};

export default OAuth2Callback;
